export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  imageUrl: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    slug: 'shouyin-zhuyi-shixiang',
    title: '手淫注意事项：避免常见的安全隐患',
    excerpt: '手淫是最常见的自慰方式之一，但如果方法不当，可能带来安全隐患。本文详细讲解正确的频率、力度和方式。',
    content: `<p>手淫（Masturbation）是最普遍的自慰方式之一，无论男女，绝大多数人都有过手淫经历。虽然这是一种正常且健康的性行为，但不正确的方式可能带来身体损伤。</p>
<h3>控制频率，避免过度</h3>
<p>适度的手淫对身体无害，但过度频繁可能导致：生殖器皮肤磨损、局部充血肿胀、甚至影响日常生活和工作效率。一般建议以不影响正常生活、不引起身体不适为原则，频率因人而异，没有绝对的标准。</p>
<h3>注意力度与润滑</h3>
<p>过大的力度可能导致阴茎或阴蒂表皮损伤。建议使用适当的润滑剂（水性润滑剂为佳），避免干涩摩擦。对于女性，指甲过长可能在自慰时划伤阴道黏膜，务必保持指甲修剪整齐。</p>
<h3>选择安全的环境</h3>
<p>确保在私密、安全的环境中进行，避免在公共场所或可能被打扰的场合自慰，这不仅是法律和道德的要求，也能减少心理压力和焦虑。</p>
<h3>避免使用危险物品</h3>
<p>切勿将不安全的异物插入体内，这可能导致异物滞留、感染甚至需要急诊手术取出。如需使用辅助工具，应选择正规生产的性健康产品。</p>`,
    category: 'anquan-xuzhi',
    author: '李医生',
    date: '2026-07-15',
    readTime: '6 分钟',
    imageUrl: 'https://mastinfo.github.io/api/search-image?query=Clean%20minimalist%20medical%20illustration%20of%20hand%20hygiene%20and%20safety%20with%20soft%20warm%20lighting%2C%20healthcare%20concept%2C%20gentle%20pastel%20cream%20background%2C%20editorial%20style%2C%20professional%20medical%20aesthetic&width=800&height=400&seq=article-shouyin-zhuyi&orientation=landscape',
    tags: ['自慰方式', '安全自慰方式', '手淫安全'],
  },
  {
    slug: 'qicai-anquan-shiyong',
    title: '情趣用品安全使用指南：选购、清洁与存放',
    excerpt: '情趣用品可以丰富自慰体验，但安全使用至关重要。从材质选择到清洁消毒，全面了解如何安全使用情趣用品。',
    content: `<p>随着社会观念的开放，越来越多的人开始使用情趣用品来丰富自慰体验。然而，情趣用品的安全使用是一个不容忽视的话题。</p>
<h3>选购要点</h3>
<p>选择正规品牌、有质量认证的产品。优先选择医用级硅胶、玻璃或不锈钢等安全材质，避免含有邻苯二甲酸盐等有害物质的劣质产品。购买时注意包装完整性，避免购买三无产品。</p>
<h3>清洁与消毒</h3>
<p>使用前后都应对情趣用品进行彻底清洁。使用专用的玩具清洁液或温和的肥皂水清洗，避免使用含酒精或腐蚀性成分的清洁剂。对于可水洗的硅胶产品，可用温水冲洗后晾干。</p>
<h3>存放方式</h3>
<p>情趣用品应存放在干燥、通风的地方，避免阳光直射。不同材质的产品应分开存放，硅胶产品之间勿直接接触，以免发生化学反应。建议使用专用的收纳袋或收纳盒。</p>
<h3>使用润滑剂</h3>
<p>配合润滑剂使用可提升舒适度和安全性。硅胶玩具应搭配水性润滑剂，避免使用硅基润滑剂，因为硅基润滑剂可能损坏硅胶材质。</p>`,
    category: 'anquan-xuzhi',
    author: '王医师',
    date: '2026-06-28',
    readTime: '7 分钟',
    imageUrl: 'https://mastinfo.github.io/api/search-image?query=Clean%20minimalist%20product%20safety%20illustration%20with%20soft%20cream%20background%2C%20hygiene%20concept%2C%20warm%20neutral%20tones%2C%20editorial%20clean%20aesthetic%2C%20healthcare%20professional%20look&width=800&height=400&seq=article-qicai-anquan&orientation=landscape',
    tags: ['自慰方式', '安全自慰方式', '情趣用品'],
  },
  {
    slug: 'teshu-qunti-zhuyi',
    title: '特殊时期的自慰安全：经期、孕期与术后',
    excerpt: '女性在经期、孕期以及术后等特殊时期进行自慰需要格外注意。本文提供针对这些特殊时期的安全建议。',
    content: `<p>女性在人生的不同阶段，身体状态会发生变化。了解特殊时期的自慰安全注意事项，对于保护身体健康至关重要。</p>
<h3>经期自慰</h3>
<p>经期自慰本身并无绝对禁忌，但需注意：保持外阴清洁，避免将细菌带入阴道；经期宫颈口微张，感染风险增加，应避免将手指或物品深入阴道；如使用卫生棉条，自慰前应取出。</p>
<h3>孕期自慰</h3>
<p>正常妊娠期间，适度自慰通常是安全的。但有以下情况的孕妇应避免：有流产史或早产风险、前置胎盘、不明原因的阴道出血、羊水破裂。孕期自慰应以体外刺激为主，避免深入刺激。</p>
<h3>术后恢复期</h3>
<p>妇科手术（如子宫肌瘤切除、剖宫产等）后，需要充分的恢复时间。一般建议术后至少等待医生复查确认恢复良好后再恢复性生活及自慰，通常需要4-6周甚至更长时间。务必遵医嘱。</p>`,
    category: 'anquan-xuzhi',
    author: '张主任',
    date: '2026-07-02',
    readTime: '8 分钟',
    imageUrl: 'https://mastinfo.github.io/api/search-image?query=Warm%20minimalist%20healthcare%20illustration%20of%20female%20wellness%20with%20soft%20pastel%20cream%20tones%2C%20gentle%20medical%20aesthetic%2C%20calm%20and%20caring%20atmosphere%2C%20editorial%20photography%20style&width=800&height=400&seq=article-teshu-qunti&orientation=landscape',
    tags: ['自慰方式', '安全自慰方式', '女性健康'],
  },
  {
    slug: 'ziwei-qianhou-qingjie',
    title: '自慰前后的清洁卫生：你必须知道的细节',
    excerpt: '良好的卫生习惯是安全自慰的基础。从手部清洁到私处护理，每一个细节都不容忽视。',
    content: `<p>自慰是一种正常的生理行为，但不注意卫生可能导致泌尿系统感染、生殖器炎症等问题。建立良好的卫生习惯，是健康自慰的第一步。</p>
<h3>自慰前的准备</h3>
<p>首先，用流动的温水和肥皂彻底清洗双手，尤其是指甲缝。指甲应修剪整齐，避免划伤脆弱的黏膜组织。如果计划使用润滑剂或情趣用品，确保它们也是清洁的。</p>
<h3>自慰后的清洁</h3>
<p>自慰结束后，应及时用温水清洗外阴区域。女性应注意从前向后清洗，避免将肛门区域的细菌带到尿道口和阴道口。男性应注意清洗龟头和包皮内侧。不建议使用香皂或沐浴露直接清洗黏膜部位，清水即可。</p>
<h3>内衣更换</h3>
<p>如果自慰后有分泌物沾染内衣，应及时更换干净的棉质内衣。棉质内衣透气性好，有助于保持私处干爽，减少细菌滋生。</p>
<h3>排尿习惯</h3>
<p>自慰后建议排尿一次，这有助于冲刷尿道中可能进入的细菌，降低尿路感染的风险，尤其对女性更为重要。</p>`,
    category: 'weisheng-yaodian',
    author: '陈护士长',
    date: '2026-07-10',
    readTime: '5 分钟',
    imageUrl: 'https://mastinfo.github.io/api/search-image?query=Clean%20minimalist%20hygiene%20illustration%20with%20soft%20cream%20background%2C%20hand%20washing%20and%20cleanliness%20concept%2C%20warm%20neutral%20healthcare%20aesthetic%2C%20editorial%20style%2C%20fresh%20and%20pure%20atmosphere&width=800&height=400&seq=article-ziwei-qingjie&orientation=landscape',
    tags: ['自慰方式', '自慰方式卫生须知', '个人卫生'],
  },
  {
    slug: 'yinyongpin-qingjie-xunhuan',
    title: '情趣用品的清洁周期与更换建议',
    excerpt: '情趣用品需要定期清洁和适时更换。了解不同材质产品的清洁方法和使用周期，保护你的私密健康。',
    content: `<p>情趣用品的卫生直接关系到使用者的健康。许多人不清楚情趣用品也有使用周期，过期或变质的材料可能成为细菌的温床。</p>
<h3>不同材质的清洁方法</h3>
<p>硅胶产品：使用后用温水和温和肥皂清洗，或在沸水中煮3-5分钟消毒（仅限纯硅胶产品）。TPE/TPR材质：不耐高温，只能用温水和专用清洁液清洗。玻璃/不锈钢：可用沸水消毒，也可用酒精擦拭。</p>
<h3>使用周期建议</h3>
<p>硅胶产品一般使用寿命为1-2年，TPE/TPR材质因多孔性更强，建议6-12个月更换。如果产品出现变色、异味、表面变黏或出现裂纹，应立即停止使用并更换。</p>
<h3>振动类产品的特别注意事项</h3>
<p>电池仓应保持干燥，长时间不使用时取出电池。可水洗的防水产品清洁后务必彻底晾干再存放，避免电池仓进水导致短路或发霉。</p>`,
    category: 'weisheng-yaodian',
    author: '陈护士长',
    date: '2026-06-20',
    readTime: '6 分钟',
    imageUrl: 'https://mastinfo.github.io/api/search-image?query=Clean%20minimalist%20product%20care%20illustration%20with%20soft%20cream%20background%2C%20maintenance%20and%20hygiene%20concept%2C%20warm%20neutral%20healthcare%20aesthetic%2C%20editorial%20clean%20look&width=800&height=400&seq=article-yinyongpin&orientation=landscape',
    tags: ['自慰方式', '自慰方式卫生须知', '情趣用品清洁'],
  },
  {
    slug: 'jiankang-zhengque-pinlv',
    title: '自慰频率多少才健康？科学告诉你答案',
    excerpt: '「多久自慰一次算正常？」这是很多人心中的疑问。本文从医学角度分析，帮助你找到适合自己的健康频率。',
    content: `<p>关于自慰频率，网络上流传着各种说法——「一周一次正常」「天天自慰会伤身」……这些说法有科学依据吗？</p>
<h3>没有绝对的「正常」标准</h3>
<p>医学上并没有规定自慰的标准频率。每个人的性欲水平、身体状况、生活压力各不相同，自慰频率也自然有所差异。判断频率是否健康的关键指标是：是否影响了你的日常生活、工作学习和人际关系。</p>
<h3>过度自慰的警示信号</h3>
<p>如果你出现以下情况，可能需要适当调整频率：生殖器持续不适或疼痛、自慰后极度疲劳影响正常活动、因自慰而逃避社交或工作、即使没有性欲也强迫自己自慰、尝试减少频率但无法做到。</p>
<h3>健康自慰的参考标准</h3>
<p>健康自慰的核心是「适度」——不影响正常生活，不给身体带来伤害，不产生心理负担。对于大多数人来说，每周1-3次是常见范围，但个别人群可能更频繁或更少，这都是正常的。</p>`,
    category: 'jiankang-zhidao',
    author: '刘教授',
    date: '2026-07-20',
    readTime: '7 分钟',
    imageUrl: 'https://mastinfo.github.io/api/search-image?query=Minimalist%20healthcare%20illustration%20of%20balanced%20lifestyle%20with%20soft%20warm%20cream%20background%2C%20wellness%20concept%2C%20calm%20and%20scientific%20atmosphere%2C%20editorial%20clean%20aesthetic&width=800&height=400&seq=article-jiankang-pinlv&orientation=landscape',
    tags: ['自慰方式', '健康自慰方式', '自慰频率'],
  },
  {
    slug: 'nannv-ziwei-chayi',
    title: '男女性自慰的生理差异与共同点',
    excerpt: '男性和女性在自慰方式、生理反应和健康影响方面既有差异也有共同之处。了解这些，有助于更好地认识自我。',
    content: `<p>虽然自慰是人类共通的性行为，但男性和女性在具体方式、生理机制和注意事项上确实存在差异。了解这些差异，有助于选择最适合自己的健康方式。</p>
<h3>生理结构的差异</h3>
<p>男性的性器官主要是外生殖器，自慰通常涉及对阴茎的直接刺激。女性的性器官则更多为内生殖器，阴蒂是重要的快感来源。这种结构差异决定了男女在自慰方式上的本质不同。</p>
<h3>高潮反应的共同点</h3>
<p>无论男女，高潮时都会经历心率加快、呼吸急促、肌肉紧张以及随后的放松感。大脑在性高潮时会释放多巴胺、催产素等神经递质，带来愉悦和满足感。这些生理反应是性别共通的。</p>
<h3>健康影响的异同</h3>
<p>对男性而言，适度自慰有助于维持前列腺健康，定期排精可能降低前列腺炎风险。对女性而言，自慰有助于缓解经期不适、改善盆底肌功能。两性共同的好处包括压力释放、改善睡眠质量和提升自我身体认知。</p>`,
    category: 'jiankang-zhidao',
    author: '刘教授',
    date: '2026-07-08',
    readTime: '8 分钟',
    imageUrl: 'https://mastinfo.github.io/api/search-image?query=Minimalist%20scientific%20illustration%20of%20human%20anatomy%20education%20with%20soft%20cream%20background%2C%20medical%20knowledge%20concept%2C%20gender%20health%2C%20editorial%20clean%20aesthetic%2C%20warm%20neutral%20tones&width=800&height=400&seq=article-nannv-chayi&orientation=landscape',
    tags: ['自慰方式', '健康自慰方式', '生理差异'],
  },
  {
    slug: 'ziwei-yu-xingongneng',
    title: '自慰与性功能：是锻炼还是伤害？',
    excerpt: '关于自慰对性功能的影响存在诸多争议。本文从循证医学角度分析，澄清自慰与早泄、勃起功能之间的关系。',
    content: `<p>「自慰会导致早泄吗？」「自慰会影响勃起功能吗？」这些问题在网络上被反复讨论，答案也众说纷纭。</p>
<h3>自慰与早泄的关系</h3>
<p>目前没有高质量科学研究证明自慰直接导致早泄。实际上，部分性治疗师会建议早泄患者通过自慰练习来延长射精时间。关键在于自慰的方式：如果习惯性地追求快速高潮，可能形成快速射精的行为模式。</p>
<h3>自慰与勃起功能</h3>
<p>适度自慰不会损害勃起功能。但需要注意的是，过度依赖特定的刺激方式（如极强的手部握力或特定的色情内容），可能导致在实际性行为中难以达到勃起——这更多是心理适应问题，而非器质性损伤。</p>
<h3>自慰作为康复训练</h3>
<p>在性治疗领域，自慰被用作多种性功能障碍的辅助治疗手段。例如，通过自慰练习帮助患者更好地了解自己的性反应周期，从而改善与伴侣的性生活质量。</p>`,
    category: 'jiankang-zhidao',
    author: '赵医师',
    date: '2026-06-30',
    readTime: '7 分钟',
    imageUrl: 'https://mastinfo.github.io/api/search-image?query=Minimalist%20medical%20consultation%20illustration%20with%20soft%20warm%20cream%20background%2C%20doctor%20patient%20education%20concept%2C%20professional%20healthcare%20aesthetic%2C%20editorial%20clean%20look&width=800&height=400&seq=article-ziwei-xingongneng&orientation=landscape',
    tags: ['自慰方式', '健康自慰方式', '性功能'],
  },
  {
    slug: 'ziwei-zuigan-xinli',
    title: '自慰后的罪恶感：从哪里来，如何化解？',
    excerpt: '许多人在自慰后会感到内疚或羞耻。这种负面情绪从何而来？又该如何建立积极健康的性心理？',
    content: `<p>据调查，相当比例的人群在自慰后会经历不同程度的罪恶感或羞耻感。这种情绪并非源于自慰本身，而是来自社会文化、家庭教育和宗教信仰的长期影响。</p>
<h3>罪恶感的来源</h3>
<p>在中国文化背景下，性话题长期以来被高度私密化甚至污名化。许多人从小接受「性是肮脏的」「自慰有害身体」等不科学的观念。这些负面信息在潜意识中积累，导致成年后即使理性上知道自慰是正常的，情感上仍会产生愧疚感。</p>
<h3>如何化解负面情绪</h3>
<p>首先，接受自慰是人类正常的性行为之一。科学研究已明确证明适度自慰对身体无害。其次，尝试对自我进行积极的性教育——阅读科学、客观的性健康资料，了解自己的身体和性反应是自然且美好的。如果罪恶感严重影响到日常生活，建议寻求心理咨询师的帮助。</p>
<h3>建立积极的性自我认同</h3>
<p>健康的性观念包括：尊重自己的身体和欲望，了解自身的性需求和边界，以不伤害自己和他人的方式满足性需求。自慰正是实现这些目标的安全途径之一。</p>`,
    category: 'xinli-jiankang',
    author: '周心理咨询师',
    date: '2026-07-18',
    readTime: '8 分钟',
    imageUrl: 'https://mastinfo.github.io/api/search-image?query=Warm%20minimalist%20mental%20health%20illustration%20with%20soft%20cream%20background%2C%20self%20acceptance%20and%20inner%20peace%20concept%2C%20gentle%20psychological%20wellness%20aesthetic%2C%20editorial%20calm%20atmosphere&width=800&height=400&seq=article-zuigan-xinli&orientation=landscape',
    tags: ['自慰方式', '自慰方式与心理健康', '罪恶感'],
  },
  {
    slug: 'ziwei-yu-banlv-guanxi',
    title: '自慰会影响伴侣关系吗？',
    excerpt: '有伴侣的人是否应该自慰？自慰会不会伤害伴侣感情？本文探讨自慰与亲密关系之间的微妙关系。',
    content: `<p>在有稳定伴侣关系的情况下，自慰往往成为一个敏感话题。一方可能觉得另一方自慰是对自己的「背叛」或「不满足」，这种误解可能导致关系紧张。</p>
<h3>自慰≠对伴侣不满</h3>
<p>首先需要明确：有伴侣的人自慰，通常不代表对伴侣不满意。自慰和伴侣性行为是两种不同的体验——前者侧重自我探索和释放，后者则包含情感交流和亲密感。两者可以共存且互补。</p>
<h3>坦诚沟通的重要性</h3>
<p>如果伴侣对你的自慰行为感到不安，最好的解决方式是开诚布公地沟通。解释自慰对你而言意味着什么——是自我照顾的一部分，而非替代伴侣的方式。同时，也倾听伴侣的感受和担忧。</p>
<h3>自慰可以改善性生活质量</h3>
<p>了解自己的身体和性反应模式，有助于更好地引导伴侣，从而提升双方的性体验。自慰也是维持性欲和性功能的一种方式，在伴侣暂时无法进行性行为时（如异地、孕期等），是健康的替代方案。</p>`,
    category: 'xinli-jiankang',
    author: '周心理咨询师',
    date: '2026-07-05',
    readTime: '7 分钟',
    imageUrl: 'https://mastinfo.github.io/api/search-image?query=Warm%20minimalist%20couple%20communication%20illustration%20with%20soft%20cream%20background%2C%20healthy%20relationship%20concept%2C%20gentle%20emotional%20connection%20aesthetic%2C%20editorial%20calm%20atmosphere&width=800&height=400&seq=article-banlv-guanxi&orientation=landscape',
    tags: ['自慰方式', '自慰方式与心理健康', '伴侣关系'],
  },
  {
    slug: 'ziwei-dachuan-hui-xuruo',
    title: '「自慰会让人虚弱」——经典误区的科学澄清',
    excerpt: '「一滴精十滴血」「自慰伤元气」……这些广为流传的说法有科学依据吗？让我们用循证医学来一一澄清。',
    content: `<p>「自慰伤身」是流传最广的性健康误区之一。在中国传统观念中，精液被视为宝贵的「元气」，因此「浪费」精液被认为会损害健康。然而，现代医学对此有截然不同的结论。</p>
<h3>「一滴精十滴血」的科学真相</h3>
<p>精液的主要成分是水（约占90%以上），其余为少量蛋白质、果糖、矿物质和精子。精液的生成是持续进行的生理过程，人体每天都会产生新的精子。射精损失的物质可以通过正常饮食轻松补充，不存在「元气大伤」的问题。</p>
<h3>自慰与免疫力的关系</h3>
<p>有研究显示，适度性活动（包括自慰）后，体内的免疫球蛋白A（IgA）水平可能略有上升，提示对免疫功能可能有正面影响。适度自慰不会降低免疫力，反而可能通过缓解压力来间接促进免疫健康。</p>
<h3>「自慰导致肾虚」的说法</h3>
<p>中医「肾虚」是一个复杂的证候概念，与现代医学的肾脏功能不完全对应。目前没有任何循证医学研究证明自慰会导致器质性肾病或肾功能损害。所谓的「自慰后腰酸背痛」，更多是肌肉紧张或姿势不当导致，而非「肾虚」。</p>`,
    category: 'changjian-wuqu',
    author: '孙博士',
    date: '2026-07-22',
    readTime: '8 分钟',
    imageUrl: 'https://mastinfo.github.io/api/search-image?query=Minimalist%20science%20education%20illustration%20with%20soft%20cream%20background%2C%20myth%20busting%20concept%2C%20fact%20vs%20fiction%2C%20warm%20editorial%20clean%20aesthetic%2C%20knowledge%20and%20truth&width=800&height=400&seq=article-dachuan-xuruo&orientation=landscape',
    tags: ['自慰方式', '自慰方式误区', '科学辟谣'],
  },
  {
    slug: 'ziwei-hui-zhangdou-diaofa',
    title: '「自慰会导致长痘和脱发」——皮肤科医生怎么说',
    excerpt: '很多青少年担心自慰会导致青春痘或脱发。皮肤科医生从专业角度解析这个广为流传的说法。',
    content: `<p>在青春期，许多青少年同时面临两个「困扰」：青春痘和性冲动。不知从何时起，这两者被联系在一起，形成了「自慰会导致长痘」的说法。</p>
<h3>青春痘的真正成因</h3>
<p>青春痘（痤疮）的发生主要与以下因素有关：雄激素水平升高导致皮脂腺分泌旺盛、毛囊角化异常、痤疮丙酸杆菌增殖、炎症反应。遗传、饮食（高糖高脂）、压力和护肤品使用不当也是重要影响因素。自慰并不在这些致病因素之中。</p>
<h3>自慰与激素水平的关系</h3>
<p>虽然自慰会引起短暂的激素波动（如催产素、多巴胺的变化），但不会导致长期的雄激素水平异常。没有科学研究证明自慰会显著改变体内激素水平到足以引发或加重痤疮的程度。</p>
<h3>脱发与自慰无关</h3>
<p>雄激素性脱发是最常见的脱发类型，与遗传和雄激素（主要是二氢睾酮DHT）的敏感性有关。自慰行为本身不会改变DHT水平或毛囊对DHT的敏感性。将脱发归咎于自慰，是没有科学依据的。</p>`,
    category: 'changjian-wuqu',
    author: '孙博士',
    date: '2026-07-12',
    readTime: '6 分钟',
    imageUrl: 'https://mastinfo.github.io/api/search-image?query=Minimalist%20dermatology%20illustration%20with%20soft%20cream%20background%2C%20skin%20health%20concept%2C%20scientific%20facts%2C%20warm%20editorial%20clean%20aesthetic%2C%20medical%20education&width=800&height=400&seq=article-zhangdou-diaofa&orientation=landscape',
    tags: ['自慰方式', '自慰方式误区', '皮肤健康'],
  },
  {
    slug: 'nuxing-ziwei-bu-zhengchang',
    title: '「女性自慰不正常」——性别偏见下的性健康误区',
    excerpt: '相比男性自慰，女性自慰承受着更多社会偏见和污名化。本文探讨这一性别不平等现象及其对女性健康的影响。',
    content: `<p>在大多数文化中，男性自慰往往被认为是「正常」甚至「不可避免」的，而女性自慰则被贴上了更多负面标签。这种双重标准反映了深层的性别不平等。</p>
<h3>女性自慰的普遍性</h3>
<p>调查数据显示，绝大多数女性在一生中都有过自慰经历。女性自慰是了解自身身体、探索性反应的最安全方式。许多女性通过自慰第一次体验到了性高潮，这对建立健康的性自我认知至关重要。</p>
<h3>社会污名化的影响</h3>
<p>「好女孩不会做这种事」「女性应该矜持」等观念，导致许多女性对自身的性欲望感到羞耻。这种羞耻感不仅影响心理健康，还可能使女性在性关系中处于被动和弱势地位，难以主动表达性需求或拒绝不安全的性行为。</p>
<h3>拥抱身体的自主权</h3>
<p>每个人都有权利了解和探索自己的身体。女性自慰不是羞耻的事，而是自我关爱和自我认知的一部分。打破性别偏见，从尊重每个人对自己身体的自主权开始。</p>`,
    category: 'changjian-wuqu',
    author: '林老师',
    date: '2026-06-25',
    readTime: '7 分钟',
    imageUrl: 'https://mastinfo.github.io/api/search-image?query=Warm%20minimalist%20feminine%20empowerment%20illustration%20with%20soft%20cream%20background%2C%20women%20health%20and%20self%20care%20concept%2C%20gentle%20confidence%20aesthetic%2C%20editorial%20clean%20atmosphere&width=800&height=400&seq=article-nuxing-buzhengchang&orientation=landscape',
    tags: ['自慰方式', '自慰方式误区', '女性健康'],
  },
  {
    slug: 'ziwei-chengyin-zenmeban',
    title: '自慰成瘾怎么办？识别信号与应对策略',
    excerpt: '如何区分正常的自慰习惯和成瘾行为？如果发现自己对自慰失去控制，应该采取哪些措施？',
    content: `<p>虽然自慰本身是健康的行为，但当它开始失控并干扰正常生活时，就可能成为需要关注的问题。需要强调的是，「自慰成瘾」并非正式的精神疾病诊断，而更接近于一种行为失控的表现。</p>
<h3>需要警惕的信号</h3>
<p>如果你出现以下情况，可能需要关注：无法控制自慰冲动，即使在不合适的时间或地点也无法抑制；自慰已影响到工作、学习或人际关系；花费大量时间寻找色情内容或计划自慰；尝试减少但反复失败；需要越来越强的刺激才能获得满足。</p>
<h3>自助调整策略</h3>
<p>首先，尝试建立规律的生活作息，增加体育锻炼和户外活动，用健康的替代活动填充可能触发自慰冲动的空闲时间。减少接触色情内容，必要时可使用内容过滤工具。学习压力管理和情绪调节技巧，因为压力和负面情绪往往是触发因素。</p>
<h3>何时寻求专业帮助</h3>
<p>如果自助调整效果不佳，或自慰行为已严重影响到生活质量，建议寻求专业心理咨询师或性治疗师的帮助。认知行为疗法（CBT）和正念疗法对行为控制问题有较好的效果。请记住，寻求帮助是勇敢和负责任的表现，而非软弱。</p>`,
    category: 'changjian-wenti',
    author: '周心理咨询师',
    date: '2026-07-25',
    readTime: '8 分钟',
    imageUrl: 'https://mastinfo.github.io/api/search-image?query=Warm%20minimalist%20self%20care%20illustration%20with%20soft%20cream%20background%2C%20healing%20and%20balance%20concept%2C%20gentle%20wellness%20aesthetic%2C%20editorial%20calm%20atmosphere%2C%20professional%20support&width=800&height=400&seq=article-chengyin-zenmeban&orientation=landscape',
    tags: ['自慰方式', '自慰方式常见问题', '行为控制'],
  },
  {
    slug: 'ziwei-yu-tongjing',
    title: '自慰能缓解痛经吗？女性自慰的额外健康益处',
    excerpt: '许多女性发现自慰有助于缓解痛经。这种现象背后的科学原理是什么？女性自慰还有哪些健康益处？',
    content: `<p>在女性健康论坛上，经常能看到「自慰可以缓解痛经」的分享。这是有科学依据的个人经验，还是心理作用？</p>
<h3>科学原理</h3>
<p>性高潮时，大脑会释放内啡肽（Endorphins）——这是一种天然的镇痛物质。内啡肽与阿片类受体结合，产生镇痛效果。此外，高潮时子宫和盆底肌的节律性收缩和随后的放松，有助于缓解子宫痉挛，改善盆腔血液循环。</p>
<h3>女性自慰的其他健康益处</h3>
<p>除了缓解痛经，女性自慰还有以下益处：帮助维持盆底肌功能，可能降低压力性尿失禁的风险；改善睡眠质量，高潮后催产素和催乳素的释放有助于入睡；缓解压力和焦虑；帮助女性更好地了解自己的性反应，提升性生活质量。</p>
<h3>注意事项</h3>
<p>如果痛经严重且持续影响生活，自慰不能替代医疗诊治。原发性痛经可通过药物（如布洛芬）治疗，继发性痛经可能是子宫内膜异位症等疾病的信号，需要及时就医检查。</p>`,
    category: 'changjian-wenti',
    author: '张主任',
    date: '2026-07-08',
    readTime: '6 分钟',
    imageUrl: 'https://mastinfo.github.io/api/search-image?query=Warm%20minimalist%20women%20wellness%20illustration%20with%20soft%20cream%20background%2C%20comfort%20and%20relief%20concept%2C%20gentle%20feminine%20health%20aesthetic%2C%20editorial%20calm%20atmosphere&width=800&height=400&seq=article-ziwei-tongjing&orientation=landscape',
    tags: ['自慰方式', '自慰方式常见问题', '女性健康'],
  },
  {
    slug: 'qingshaonian-ziwei-jiaoyu',
    title: '青少年自慰：家长如何正确引导？',
    excerpt: '青少年时期是性意识觉醒的阶段，自慰行为在这一阶段非常普遍。家长应如何以科学、开放的态度面对？',
    content: `<p>面对孩子的自慰行为，许多家长感到尴尬、担忧甚至愤怒。然而，正确的引导方式对青少年的性心理健康至关重要。</p>
<h3>理解青少年的性发展</h3>
<p>青春期是性激素水平急剧变化的时期，性冲动和自慰行为在这一阶段是完全正常的生理现象。研究表明，绝大多数青少年在青春期有过自慰经历。将其视为「道德问题」或「疾病」，只会给孩子带来不必要的心理负担。</p>
<h3>如何与孩子沟通</h3>
<p>首先，家长需要调整自己的心态——自慰不是可耻的行为。沟通时注意：不指责、不羞辱、不恐吓。可以选择在适当的情境下（如一起观看性教育相关节目后）自然地引入话题。如果感到难以开口，可以为孩子提供科学、适合其年龄的性教育书籍。</p>
<h3>需要引导的方面</h3>
<p>家长应该帮助孩子了解：自慰应在私密空间进行，这是对自我和他人的尊重；注意卫生，避免损伤；自慰不应影响正常的学习和生活；网络色情内容不等同于真实的性，需要理性看待。</p>`,
    category: 'changjian-wenti',
    author: '林老师',
    date: '2026-06-15',
    readTime: '8 分钟',
    imageUrl: 'https://mastinfo.github.io/api/search-image?query=Warm%20minimalist%20parenting%20education%20illustration%20with%20soft%20cream%20background%2C%20family%20communication%20concept%2C%20gentle%20guidance%20aesthetic%2C%20editorial%20clean%20atmosphere&width=800&height=400&seq=article-qingshaonian&orientation=landscape',
    tags: ['自慰方式', '自慰方式常见问题', '青少年教育'],
  },
];

export const articleMap: Record<string, Article> = {};
articles.forEach((a) => { articleMap[a.slug] = a; });

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((a) => a.category === slug);
}

export function getRelatedArticles(currentSlug: string, category: string, count: number = 3): Article[] {
  return articles
    .filter((a) => a.category === category && a.slug !== currentSlug)
    .slice(0, count);
}